import React from 'react';
//styles
import "./Navbar.css"

const Navbar = () => {
    return (
        <nav>Expense Tracker</nav>
    );
};

export default Navbar;